/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FeedbackSchedule,
    FeedbackScheduleFromJSON,
    FeedbackScheduleFromJSONTyped,
    FeedbackScheduleToJSON,
} from './FeedbackSchedule';
import {
    ProgramAttendeeIgnoredConflict,
    ProgramAttendeeIgnoredConflictFromJSON,
    ProgramAttendeeIgnoredConflictFromJSONTyped,
    ProgramAttendeeIgnoredConflictToJSON,
} from './ProgramAttendeeIgnoredConflict';
import {
    RequiredAttendeeFields,
    RequiredAttendeeFieldsFromJSON,
    RequiredAttendeeFieldsFromJSONTyped,
    RequiredAttendeeFieldsToJSON,
} from './RequiredAttendeeFields';
import {
    SalesEndType,
    SalesEndTypeFromJSON,
    SalesEndTypeFromJSONTyped,
    SalesEndTypeToJSON,
} from './SalesEndType';
import {
    Treaty,
    TreatyFromJSON,
    TreatyFromJSONTyped,
    TreatyToJSON,
} from './Treaty';

/**
 * 
 * @export
 * @interface Preferences
 */
export interface Preferences {
    /**
     * 
     * @type {number}
     * @memberof Preferences
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    brand_accent_color?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    default_event_waiver?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    default_membership_terms?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    program_terms?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    membership_packages_text?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    store_front_text?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    session_packages_text?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    checkout_background_url?: string;
    /**
     * 
     * @type {number}
     * @memberof Preferences
     */
    checkout_overlay_opacity?: number;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    checkout_overlay_color?: string;
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    sold_out_text?: string;
    /**
     * 
     * @type {SalesEndType}
     * @memberof Preferences
     */
    default_sales_end?: SalesEndType;
    /**
     * 
     * @type {FeedbackSchedule}
     * @memberof Preferences
     */
    camp_feedback_schedule?: FeedbackSchedule;
    /**
     * 
     * @type {FeedbackSchedule}
     * @memberof Preferences
     */
    session_feedback_schedule?: FeedbackSchedule;
    /**
     * 
     * @type {RequiredAttendeeFields}
     * @memberof Preferences
     */
    required_attendee_fields?: RequiredAttendeeFields;
    /**
     * 
     * @type {Treaty}
     * @memberof Preferences
     */
    treaty?: Treaty;
    /**
     * 
     * @type {Array<ProgramAttendeeIgnoredConflict>}
     * @memberof Preferences
     */
    ignore_attendee_conflicts?: Array<ProgramAttendeeIgnoredConflict>;
    /**
     * 
     * @type {boolean}
     * @memberof Preferences
     */
    promote_products?: boolean;
}

export function PreferencesFromJSON(json: any): Preferences {
    return PreferencesFromJSONTyped(json, false);
}

export function PreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Preferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': json['version'],
        'brand_accent_color': !exists(json, 'brand_accent_color') ? undefined : json['brand_accent_color'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'default_event_waiver': !exists(json, 'default_event_waiver') ? undefined : json['default_event_waiver'],
        'default_membership_terms': !exists(json, 'default_membership_terms') ? undefined : json['default_membership_terms'],
        'program_terms': !exists(json, 'program_terms') ? undefined : json['program_terms'],
        'membership_packages_text': !exists(json, 'membership_packages_text') ? undefined : json['membership_packages_text'],
        'store_front_text': !exists(json, 'store_front_text') ? undefined : json['store_front_text'],
        'session_packages_text': !exists(json, 'session_packages_text') ? undefined : json['session_packages_text'],
        'checkout_background_url': !exists(json, 'checkout_background_url') ? undefined : json['checkout_background_url'],
        'checkout_overlay_opacity': !exists(json, 'checkout_overlay_opacity') ? undefined : json['checkout_overlay_opacity'],
        'checkout_overlay_color': !exists(json, 'checkout_overlay_color') ? undefined : json['checkout_overlay_color'],
        'sold_out_text': !exists(json, 'sold_out_text') ? undefined : json['sold_out_text'],
        'default_sales_end': !exists(json, 'default_sales_end') ? undefined : SalesEndTypeFromJSON(json['default_sales_end']),
        'camp_feedback_schedule': !exists(json, 'camp_feedback_schedule') ? undefined : FeedbackScheduleFromJSON(json['camp_feedback_schedule']),
        'session_feedback_schedule': !exists(json, 'session_feedback_schedule') ? undefined : FeedbackScheduleFromJSON(json['session_feedback_schedule']),
        'required_attendee_fields': !exists(json, 'required_attendee_fields') ? undefined : RequiredAttendeeFieldsFromJSON(json['required_attendee_fields']),
        'treaty': !exists(json, 'treaty') ? undefined : TreatyFromJSON(json['treaty']),
        'ignore_attendee_conflicts': !exists(json, 'ignore_attendee_conflicts') ? undefined : ((json['ignore_attendee_conflicts'] as Array<any>).map(ProgramAttendeeIgnoredConflictFromJSON)),
        'promote_products': !exists(json, 'promote_products') ? undefined : json['promote_products'],
    };
}

export function PreferencesToJSON(value?: Preferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'brand_accent_color': value.brand_accent_color,
        'logo': value.logo,
        'icon': value.icon,
        'default_event_waiver': value.default_event_waiver,
        'default_membership_terms': value.default_membership_terms,
        'program_terms': value.program_terms,
        'membership_packages_text': value.membership_packages_text,
        'store_front_text': value.store_front_text,
        'session_packages_text': value.session_packages_text,
        'checkout_background_url': value.checkout_background_url,
        'checkout_overlay_opacity': value.checkout_overlay_opacity,
        'checkout_overlay_color': value.checkout_overlay_color,
        'sold_out_text': value.sold_out_text,
        'default_sales_end': SalesEndTypeToJSON(value.default_sales_end),
        'camp_feedback_schedule': FeedbackScheduleToJSON(value.camp_feedback_schedule),
        'session_feedback_schedule': FeedbackScheduleToJSON(value.session_feedback_schedule),
        'required_attendee_fields': RequiredAttendeeFieldsToJSON(value.required_attendee_fields),
        'treaty': TreatyToJSON(value.treaty),
        'ignore_attendee_conflicts': value.ignore_attendee_conflicts === undefined ? undefined : ((value.ignore_attendee_conflicts as Array<any>).map(ProgramAttendeeIgnoredConflictToJSON)),
        'promote_products': value.promote_products,
    };
}

